import Connector from './connector.js';

/**
 * A class that represents an output connector of a node.
 * */
export default class OutputConnector extends Connector
{
	constructor(eType, strName, pParentNode)
	{
		super(eType, strName, pParentNode);

		this.connectedNodeInfos = [];
	}

	isConnectedTo(iNodeId, strInputName)
	{
		for(let pInfo of this.connectedNodeInfos)
		{
			if(pInfo.nodeId == iNodeId && pInfo.inputName == strInputName)
				return true;
		}

		return false;
	}

	disconnect(optNodeId, strOptInputName)
	{
		let pSubnet = this.getOwnNode().getParent();
		for(let idx = this.connectedNodeInfos.length - 1; idx >= 0; idx--)
		{
			let pConnectedInfo = this.connectedNodeInfos[idx];
			if(optNodeId && optNodeId != pConnectedInfo.nodeId)
				continue;

			if(optNodeId && optNodeId == pConnectedInfo.nodeId && strOptInputName && strOptInputName != pConnectedInfo.inputName)
				continue;

			this.connectedNodeInfos.splice(idx, 1);

			let pOtherNode = pSubnet.getNode(pConnectedInfo.nodeId);
			if(pOtherNode)
			{
				let pInput = pOtherNode.getInput(pConnectedInfo.inputName);
				if(pInput)
					pInput.disconnect();
			}
		}
	}

	renameConnectedInputInfoUnsafe(pNode, strOldInputName, strNewInputName)
	{
		for(let pInfo of this.connectedNodeInfos)
		{
			if(pInfo.nodeId === pNode.getId() && pInfo.inputName === strOldInputName)
				pInfo.inputName = strNewInputName;
		}
	}

	renameInputConnectedNamesUnsafe(strNewName)
	{
		let pSubnet = this.getOwnNode().getParent();
		for(let pInfo of this.connectedNodeInfos)
		{
			let pConnectedNode = pSubnet.getNode(pInfo.nodeId);
			let pConnectedInput = pConnectedNode.getInput(pInfo.inputName);
			pConnectedInput.renameConnectedOuputUnsafe(strNewName);
		}
	}

	saveToObject()
	{
		let pRes = super.saveToObject();
		pRes['cnis'] = [];
		for(let pInfo of this.connectedNodeInfos)
			pRes['cnis'].push({'n': pInfo.nodeId, 'i': pInfo.inputName});
		return pRes;
	}

	loadFromObject(pObj)
	{
		super.loadFromObject(pObj);
		this.connectedNodeInfos = [];
		if(pObj['cnis'])
		{
			for(let pInfo of pObj['cnis'])
				this.connectedNodeInfos.push({nodeId: pInfo['n'], inputName: pInfo['i']});
		}
	}

	finishConnectionTo(otherNodeId, inputName)
	{
		this.connectedNodeInfos.push({nodeId: otherNodeId, inputName: inputName});
	}

	getConnectedNodeInfos()
	{
		return this.connectedNodeInfos;
	}
}